import handshake from '../../img/svg/handshake.svg';
import checkbox from '../../img/svg/checkbox.svg';
import monitor from '../../img/svg/monitor.svg';
import lightbulb from '../../img/svg/lightbulb.svg';

export default function injectPartnerPage() {
    /* ----------------------------------- */
    /* add pill button section to the page */
    /* ----------------------------------- */

    let courseContent = document.querySelector('#skilljar-content #catalog-content');

    let pillButtonSection = document.createElement('DIV');
    pillButtonSection.classList.add("pill-button-section");

    let pillButtons = [
        {
            icon: handshake,
            text: "Partner Development",
            url: "/page/partner-development",
            target: "",
        },
        {
            icon: checkbox,
            text: "Use Cases",
            url: "/page/use-cases",
            target: "",
        },
        {
            icon: monitor,
            text: "Live Training",
            url: "/page/live-training",
            target: "",
        },
        {
            icon: lightbulb,
            text: "ClickTips",
            url: "/page/clicktips",
            target: "",
        },
    ];

    for (let item of pillButtons) {
        let pillButton = document.createElement('DIV');

        pillButton.classList.add('pill-button');
        pillButton.innerHTML = `
            <a href="${item.url}" target=${item.target}>
                <div class="pill-icon">
                    <img src="${item.icon}">
                </div>
                <p>${item.text}</p>
            </a>
        `;

        pillButtonSection.append(pillButton);
    }

    courseContent.before(pillButtonSection);


    /* ------------------------------- */
    /* add course cards section header */
    /* ------------------------------- */

    let courseCardSection = document.querySelector('#skilljar-content #catalog-content #catalog-courses');

    let courseCardsDescription = document.createElement('DIV');
    courseCardsDescription.id = 'learning-paths-description';
    courseCardsDescription.classList.add('course-card-description');
    courseCardsDescription.innerHTML = `
        <p>Become a Qualified ClickUp Partner by completing core enablement journeys relevant to your role.</p>
        <p>Your journeys are automatically assigned based on the role you chose in the Partner Portal.</p>
        <p><strong>Ready to learn more?</strong> Browse the <a class="injected-link" href="/page/course-catalog">All Courses</a> page to explore more content.</p>
    `;
    
    courseCardSection.prepend(courseCardsDescription);


    /* ----------------------------------------- */
    /* add FAQ section to the bottom of the page */
    /* ----------------------------------------- */

    let pageContent = document.querySelector('#skilljar-content');

    let faqSection = document.createElement('DIV');
    faqSection.id = 'faq-section';
    faqSection.classList.add('extra-section');
    faqSection.innerHTML = `
        <h2>Questions about Partner Enablement?</h2>
    `;

    let contactButton = document.createElement('A');
    contactButton.classList.add('faq-contact-button');
    contactButton.href = 'mailto:partnerenablement@clickup.com';
    contactButton.innerText = 'Contact Us';

    faqSection.append(contactButton);

    pageContent.append(faqSection);
};
